export default function getFlagUrl(lang: string) {
  return new URL(`/src/images/flags/${lang}.svg`, import.meta.url).href
}
